<template>
    <v-container class="pa-4 text-center">
        <p class="display-1 font-weight-light">Riwayat Order</p>
        <template>
            <div>
                <v-data-table
                    :headers="headers"
                    :items="listOrder"
                    :loading="loading"
                    class="elevation-1"
                    color="green lighten-1"
                >
                <template v-slot:item.status="{ item }">
                    <v-chip :color="getColor(item.status)" dark>{{ item.status == 'APPROVED' ? 'UNPAID' : item.status }}</v-chip>
                </template>
                <template v-slot:item.action="{ item }">
                    <v-btn outlined x-small fab color="teal" @click="getDetailOrder(item.id)">
                        <v-icon>info</v-icon>
                    </v-btn>
                </template>
                </v-data-table>
            </div>
        </template>
    </v-container>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import { forEach, findIndex } from "lodash";
export default {
    name: "Pemesanan",
    data () {
      return {
        totalData: 0,
        loading: true,
        options: {},
        headers: [
          {
            text: 'Nama',
            align: 'start',
            value: 'name',
            class: 'white--text'
          },
          {text: 'Total Harga',value: 'total',class: 'white--text'},
          {text: 'Status',value: 'status',class: 'white--text'},
          {text: 'Tanggal',value: 'date',class: 'white--text'},
          {text: 'Action',value: 'action',class: 'white--text'},
        ],
      }
    },
    watch: {
      options: {
        handler () {
          this.getDataFromApi()
        },
        deep: true,
      },
    },
    computed:{
        ...mapState({
            listOrder: state => state.pesanan.listOrder
        }),
    },
    mounted () {
      this.getDataFromApi()
    },
    methods: {
      ...mapActions({
        dataOrder: "pesanan/getPesanans",
        detailOrder: "pesanan/detailOrder"
      }),
      ...mapMutations({
        setListOrder : "pesanan/SET_LIST_ORDER",
        setDialogOrder: "pesanan/SET_DIALOG_ORDER",
        setIdDialogOrder: "pesanan/SET_ID_DIALOG_ORDER"
      }),
      async getDataFromApi () {
        this.loading = true
        const response = await this.dataOrder()
        let dataOrder = []

        if(response.status == 200){
            forEach(response.data, data => {
                data.total = Number(data.total)
                dataOrder.push(data)
            })

            this.setListOrder(dataOrder)
            this.totalData = dataOrder.length
        }else{
            console.log(response)
        }

        // console.log(this.listOrder, 'listOrder')
        this.loading = false
        // return new Promise((resolve, reject) => {
        //   const { sortBy, sortDesc, page, itemsPerPage } = this.options

        //   let items = []
        //   let total = 0
        //   this.dataPesanan().then( response => {
        //     console.log('order', response.data)
        //     items = response.data

        //     forEach(items, item => {
        //         item.total = 'Rp. ' + Number(item.total)
        //     })

        //     total = items.length

        //     if (sortBy.length === 1 && sortDesc.length === 1) {
        //         items = items.sort((a, b) => {
        //         const sortA = a[sortBy[0]]
        //         const sortB = b[sortBy[0]]

        //         if (sortDesc[0]) {
        //             if (sortA < sortB) return 1
        //             if (sortA > sortB) return -1
        //             return 0
        //         } else {
        //             if (sortA < sortB) return -1
        //             if (sortA > sortB) return 1
        //             return 0
        //         }
        //         })
        //     }

        //     if (itemsPerPage > 0) {
        //         items = items.slice((page - 1) * itemsPerPage, page * itemsPerPage)
        //     }
        //   })

        // })
      },
      getColor (status) {
        if (status == 'APPROVED') return 'orange'
        else if (status == 'PARTIAL') return 'blue'
        else return 'green'
      },
      getDetailOrder(id){
        this.setIdDialogOrder(id)
        this.detailOrder()
        this.setDialogOrder(true)
      }
    },
};
</script>
<style>
.v-data-table-header {
    background-color: #00897B;
}
</style>
